import Main from "./pages";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
